import React from "react";

export const SmallArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M5.99998 7.75002C5.86868 7.75024 5.73862 7.72452 5.61729 7.67432C5.49596 7.62413 5.38575 7.55045 5.29298 7.45752L2.64648 4.81052L3.35348 4.10352L5.99998 6.75002L8.64648 4.10352L9.35349 4.81052L6.70698 7.45702C6.61426 7.55004 6.50407 7.62381 6.38273 7.67409C6.2614 7.72438 6.13132 7.75018 5.99998 7.75002Z"
      fill="#706A85"
    />
  </svg>
);
